import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Autocomplete,Box,Button,Checkbox,Chip,FormControl,InputLabel,ListItemText,MenuItem,Select,TextField,Typography } from "@mui/material";
import { useContext,useEffect,useState } from "react";
import { WebFormContext } from "../../../../context/WebFormContext";
import { trackEventMatomo } from "../../../../helpers/matomo";
import { SubItemFormFilling } from "../../../../types/new-form-filling/types";
import CheckIcon from "../../CheckIcon";
import AdditionalInfo from "../../Structure/AdditionalInfo";

type props = {
  subitem: SubItemFormFilling,
  multiplo: string[],
  setMultiplo: Function,
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


export default function AutoCompleteMultiple({
  subitem,
  multiplo,
  setMultiplo }: props) {
  const { ForceUpdate } = useContext(WebFormContext);
  const [changeInput, setChangeInput] = useState(true);

  const textFieldTitle: string = (() => {
    let title = '';
    if (CheckIcon(subitem, multiplo) === 'naoOk') {
      title += '* ';
    }
    title += `${subitem.id + 1} - ${subitem.nome}`;
    return title;
  })();

  useEffect(() => {
    if (subitem.selecionados) {
      subitem.selecionados?.map((ele, ind) => {
        if (ele === true) {
          setMultiplo((prev: string[]) => prev ? [...prev, (subitem.selecao as string[])[ind]] : [(subitem.selecao as string[])[ind]]);
          return true;
        }
        return false;
      });
    } else if (Array.isArray(subitem.padrao) && subitem.padrao.length > 0) {
      setMultiplo(subitem?.padrao?.map((indice) => (subitem?.selecao as string[])[parseInt(indice as unknown as string, 10)]));
      const novo = Array(subitem?.selecao?.length)?.fill(false);
      multiplo?.forEach((item: string) => {
        const index = subitem?.selecao?.indexOf(item) ?? -1;
        if (index !== -1 && novo) {
          novo[index] = true;
        }
      });
    }
    if (CheckIcon(subitem, multiplo) === 'ok' && subitem?.selecionados?.some((ele) => ele === true)) {
      subitem.checked = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const novo = Array(subitem?.selecao?.length)?.fill(false);
    multiplo?.forEach((item: string) => {
      const index = subitem?.selecao?.indexOf(item) ?? -1;
      if (index !== -1 && novo) {
        novo[index] = true;
      }
    });
    if (novo?.some((ele) => ele === true)) {
      subitem.selecionados = novo;
    }
    if (CheckIcon(subitem, multiplo) === 'ok' && subitem?.selecionados?.some((ele) => ele === true)) {
      subitem.checked = true;
    }
    ForceUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [multiplo]);



  function MultiploMobile() {
    return (
      <>
        {changeInput ? <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Selecione o valor</InputLabel>
          <Select
            multiple
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={multiplo ?? []}
            label="Selecione o valor"
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip key={value} label={value} />
                ))}
              </Box>
            )}
            onChange={(event) => {
              setMultiplo(event.target.value);
              if (!event.target.value?.length) {
                delete subitem.selecionados;
                delete subitem.checked;
              }
            }}
          >
            {subitem?.selecao?.map((option, index) => {
              return (
                <MenuItem key={index} value={option}>
                  <Checkbox checked={multiplo.includes(option)} />
                  <ListItemText primary={option} />
                </MenuItem>
              );
            }
            )}
          </Select>
        </FormControl> :
          <Autocomplete
            style={{
              height: '100%',
              backfaceVisibility: 'hidden',
            }}
            renderOption={(props, option, { selected }) => {
              const { key, ...optionProps } = props;
              return (
                <li key={key} {...optionProps}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option}
                </li>
              );
            }}
            disableCloseOnSelect
            className={`${subitem.itemid}|${subitem.id}`}
            onClick={() => trackEventMatomo('formSubitem', 'click', 'input', 'edngita valor')}
            noOptionsText={'Sem opções...'}
            loadingText={'Carregando...'}
            autoComplete
            getOptionLabel={option => option as string}
            isOptionEqualToValue={(option, value) => option === value}
            value={multiplo?.map((ele) => ele) || [] || null}
            fullWidth={true}
            multiple
            options={
              subitem?.selecao?.map((option: string) => (
                option
              )) || []
            }
            onChange={(event, newValue) => {
              event.preventDefault();
              setMultiplo(newValue?.map((ele) => ele));
              if (!newValue?.length) {
                setMultiplo(null);
                delete subitem.selecionados;
                delete subitem.checked;
              }
            }
            }
            renderInput={(params) =>
              <TextField
                required={subitem.obrigatoriedade?.preenchimento}
                {...params}
                placeholder="Selecione os valores"
              />}
            renderTags={(value, getTagProps) =>
              value?.map((option, index) => (
                <Chip
                  label={option}
                  {...getTagProps({ index })}
                  style={{
                    maxWidth: 200,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                  key={index}
                />
              ))
            }
          />}
        <Button onClick={() => setChangeInput(!changeInput)}>{`${changeInput ? 'Habilitar autocomplete' : 'Desabilitar autocomplete'}`}</Button>
      </>
    );
  }

  function MultiploWeb() {
    return (
      <Autocomplete
        style={{
          height: '100%',
          backfaceVisibility: 'hidden',
        }}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option}
            </li>
          );
        }}
        disableCloseOnSelect
        className={`${subitem.itemid}|${subitem.id}`}
        onClick={() => trackEventMatomo('formSubitem', 'click', 'input', 'edngita valor')}
        noOptionsText={'Sem opções...'}
        loadingText={'Carregando...'}
        autoComplete
        getOptionLabel={option => option as string}
        isOptionEqualToValue={(option, value) => option === value}
        value={multiplo?.map((ele) => ele) || [] || null}
        fullWidth={true}
        multiple
        options={
          subitem?.selecao?.map((option: string) => (
            option
          )) || []
        }
        onChange={(event, newValue) => {
          event.preventDefault();
          setMultiplo(newValue?.map((ele) => ele));
          if (!newValue?.length) {
            setMultiplo(null);
            delete subitem.selecionados;
            delete subitem.checked;
          }
        }
        }
        renderInput={(params) =>
          <TextField
            required={subitem.obrigatoriedade?.preenchimento}
            {...params}
            placeholder="Selecione os valores"
          />}
        renderTags={(value, getTagProps) =>
          value?.map((option, index) => (
            <Chip
              label={option}
              {...getTagProps({ index })}
              style={{
                maxWidth: 200,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              key={index}
            />
          ))
        }
      />);
  }
  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {textFieldTitle}
      </Typography>
      {navigator.userAgent.includes('Mobile') || navigator.userAgent.includes('Android/iPhone') 
        ? <MultiploMobile />
        : <MultiploWeb />}
      {multiplo?.length > 0 && <AdditionalInfo subItem={subitem} />}
    </>
  );
}